import { GroupListOrderKey } from '../domain';
import { useSetFilter } from '../../filter';

export const useSetGroupListOrder = () => {
  return useSetFilter(GroupListOrderKey, 'groupOrderBy', true);
};
